import React from 'react';
import { getPermissionsForModule, Scopes } from 'src/app/scopes/scopes';

import Admins from './Children/Admins';
import Configuration from './Children/Configuration';
import Create from './Children/Create';
import Update from './Children/Update';
import ProfileAdmins from './Children/ProfileAdmins';
import PasswordRecovery from './Children/PasswordRecovery';

export const AdminConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'adminGroup',
      path: 'admin',
      scopes: getPermissionsForModule('Admins'),
      children: [
        {
          scopes: [Scopes.Admins.show],
          id: 'adminGroup.access',
          path: '',
          element: <Admins />,
        },
        {
          scopes: [Scopes.Admins.show],
          id: 'adminGroup.profile',
          path: 'profile/:id',
          element: <ProfileAdmins />,
        },
        {
          scopes: [Scopes.Admins.store],
          id: 'adminGroup.create',
          path: 'create',
          element: <Create />,
        },
        {
          scopes: [Scopes.Admins.update],
          id: 'adminGroup.update',
          path: 'update/:id?',
          element: <Update />,
        },
        {
          scopes: [Scopes.Admins.update],
          id: 'adminGroup.passwordRecovery',
          path: 'recovery/:id?',
          element: <PasswordRecovery />,
        },
        {
          // TODO: Add config scope
          // scopes: [Scopes.Admin.Admins.config],
          id: 'adminGroup.configuration',
          path: 'configuration',
          element: <Configuration />,
        },
      ],
    },
  ],
};
